<div class="filter-item-container" fxLayout="row" fxLayoutAlign="start center">
  <button mat-icon-button color="primary" (click)="onDelete()" aria-label="Delete filter">
    <mat-icon>delete</mat-icon>
  </button>
  <div fxFlex fxLayout="column" [class.warning]="selectedFilter.showFieldDeletedWarning">
    <div fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px">
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        fxFlex="35"
        [class.mat-form-field-invalid]="selectedFilter.isFilterApplied && !selectedFilter.filter"
      >
        <input
          type="text"
          placeholder="Search filters..."
          matInput
          [formControl]="myControl"
          [matAutocomplete]="auto"
          aria-label="Search for a filter"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="autocompleteSelectedChanged($event.option.value)"
        >
          <div *ngFor="let group of filteredOptions | async" class="select-group">
            <p>{{ group.name }}</p>
            <mat-option
              *ngFor="let filter of group.filters"
              [value]="filter"
              matTooltip="{{ filter.displayName }}"
              matTooltipShowDelay="300"
              >{{ filter.displayName }}</mat-option
            >
            <mat-divider></mat-divider>
          </div>
        </mat-autocomplete>
      </mat-form-field>

      <div class="odata-operators" *ngIf="selectedFilter.filter">
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="dropdown-field"
          fxFlex
          [class.mat-form-field-invalid]="selectedFilter.isFilterApplied && !selectedFilter.filterOperator"
        >
          <mat-select
            [(ngModel)]="selectedFilter.filterOperator"
            (selectionChange)="onOperatorsSelectionChange()"
            aria-label="Select an operator"
          >
            <mat-option *ngFor="let op of operators" [value]="op">{{ op.displayName }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="odata-value"
        *ngIf="
          selectedFilter.filter && selectedFilter.filterOperator && selectedFilter.filterOperator.isSearchValueNeeded
        "
        fxFlex
      >
        <multiselect
          *ngIf="selectedFilter.uiType == uiType.Multiselect"
          [items]="multiselectItems"
          [selectedItems]="selectedMultiselectItems"
          (selectionChanged)="multiselectSelectionChanged($event)"
          [placeholder]="'Select items...'"
          [required]="selectedFilter.isFilterApplied"
          [isTouched]="selectedFilter.isFilterApplied"
          aria-label="Select a value or values"
        ></multiselect>
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          fxFlex
          class="dropdown-field"
          *ngIf="selectedFilter.uiType == uiType.DropDown"
          [class.mat-form-field-invalid]="
            selectedFilter.isFilterApplied &&
            (selectedFilter.searchValue == null || selectedFilter.searchValue.toString() == '')
          "
        >
          <mat-select
            [(ngModel)]="selectedFilter.searchValue"
            (selectionChange)="selectedFilter.isFilterApplied = false"
            aria-label="Select a value"
          >
            <ng-container
              *ngIf="selectedFilter.filterOperator.behaveAs == 'List' || selectedFilter.filter.valueType == 'List'"
            >
              <mat-option
                *ngFor="let value of listItems"
                [value]="value"
                matTooltip="{{ value }}"
                matTooltipShowDelay="300"
                >{{ value }}</mat-option
              >
            </ng-container>
            <ng-container *ngIf="selectedFilter.filter.valueType == 'Boolean'">
              <mat-option
                *ngFor="let value of selectedFilter.filter.values"
                [value]="value.searchValue"
                matTooltip="{{ value.name }}"
                matTooltipShowDelay="300"
                >{{ value.name }}</mat-option
              >
            </ng-container>
          </mat-select>
        </mat-form-field>
        <div
          class="inputs"
          *ngIf="selectedFilter.uiType == uiType.Textbox || selectedFilter.uiType == uiType.DatePicker"
        >
          <mat-form-field
            *ngIf="selectedFilter.uiType == uiType.Textbox"
            appearance="outline"
            fxFlex
            [class.mat-form-field-invalid]="selectedFilter.isFilterApplied && !selectedFilter.searchValue"
          >
            <input
              matInput
              [type]="inputType"
              [(ngModel)]="selectedFilter.searchValue"
              (change)="selectedFilter.searchValue = selectedFilter.searchValue.trim()"
              (ngModelChange)="selectedFilter.isFilterApplied = false"
              [placeholder]="textBoxPlaceholder"
              aria-label="Type a value"
            />
          </mat-form-field>
          <mat-form-field
            *ngIf="selectedFilter.uiType == uiType.DatePicker"
            appearance="outline"
            fxFlex
            [class.mat-form-field-invalid]="selectedFilter.isFilterApplied && !selectedFilter.searchValue"
          >
            <input
              matInput
              [matDatepicker]="datePicker"
              [(ngModel)]="selectedFilter.searchValue"
              (ngModelChange)="selectedFilter.isFilterApplied = false"
              aria-label="Select or type a date value"
            />
            <mat-datepicker-toggle matSuffix [for]="datePicker"> </mat-datepicker-toggle>
            <mat-datepicker #datePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <button
        *ngIf="showAddConditionButton"
        class="add-filter-button"
        mat-button
        color="primary"
        (click)="onAddSubFilter()"
      >
        + ADD CONDITION
      </button>
    </div>
  </div>
</div>
<p *ngIf="selectedFilter.showFieldDeletedWarning" class="error-message">
  This field no longer exists. Remove it from the saved view and then select Save Changes.
</p>
